import { StopOutlined } from '@ant-design/icons';
import NachWrapper from './NachWrapper';
import { ReactDOM } from 'react';

interface Props {
  title: string;
  subTitle: string;
  className?: string;
  //   style?:str
  styleContainer?: React.CSSProperties;
  style?: React.CSSProperties;
  icon?: ReactDOM;
}

const NoDataFound = ({ title, subTitle, style, styleContainer, icon }: Props) => {
  return (
    <NachWrapper title={title} style={{ fontFamily: 'sans-serif', ...styleContainer }}>
      <div
        style={{
          padding: '0px 20px',
          fontSize: '18px',
          color: 'red',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          marginBottom: '5px',
          ...style,
        }}
      >
        {icon ? <>{icon} </> : <StopOutlined style={{ fontSize: '22px' }} />}
        {subTitle}
      </div>
    </NachWrapper>
  );
};

export default NoDataFound;
